const isMobile = () => {
  try {
    let temp = document.createElement("div");
    temp.className = "is-m-site";
    document.body.appendChild(temp);
    // 判断此时的 temp 的 z-index 是不是 540
    let zIndex = parseInt(window.getComputedStyle(temp).getPropertyValue("z-index"), 10);
    document.body.removeChild(temp);
    if (zIndex <= 540) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    // console.log("isMobile", 0, e);
    return false;
  }
};

export const state = () => ({
  // mNavIsShow: false,
  isMobileSite: isMobile(),
  isIE: typeof window !== "undefined" && window.isIE > -1,
});

export const mutations = {
  // toggleMNavShow(_state, value) {
  //     if (value !== undefined) {
  //         _state.mNavIsShow = value;
  //     } else {
  //         _state.mNavIsShow = !_state.mNavIsShow;
  //     }
  // },
  /**
   * 获取设备状态
   * @param {Object} _state 状态对象
   */
  getDeviceState(_state) {
    _state.isMobileSite = isMobile();
  },
};



// WEBPACK FOOTER //
// ./src/store/index.js